import * as ReactDOM from 'react-dom';
import * as React from 'react';

import { Provider } from 'react-redux';
import { HashRouter, Route, Switch, withRouter, BrowserRouter, Router } from 'react-router-dom';
import thunk from 'redux-thunk';
import { createStore, applyMiddleware } from 'redux';
import reducers from './reducers';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';

import Home from './pages/Home';
import Login from './pages/Login';
import Signup from './pages/Signup';

import AuthModal from './components/AuthModal';

import Navbar from './components/Navbar';
import Footer from './components/Footer';

import './config/i18next';

import { USER_LOGIN, USER_LOGOUT } from './reducers/auth';
import Axios from 'axios';
import AudioPlayer from './components/AudioPlayer';
import Videoclub from './pages/Videoclub';
import { EVideoclub } from './interfaces';
import VideoclubView from './pages/VideoclubView';
import NotFound from './pages/NotFound';
import Music from './pages/Music';
import ScrollToTop from './components/ScrollToTop';
import Videoclip from './pages/Videoclip';
import SerialView from './pages/SerialView';
import VideoclipView from './pages/VideoclipView';
import Football from './pages/Football';
import FootballView from './pages/FootballView';
import Concert from './pages/Concert';
import ConcertView from './pages/ConcertView';
import Festival from './pages/Festival';
import FestivalView from './pages/FestivalView';
import ShowBusiness from './pages/ShowBusiness';
import ShowBusinessView from './pages/ShowBusinessView';
import Wallpaper from './pages/Wallpaper';
import Album from './pages/Album';
import AlbumView from './pages/AlbumView';
import Singer from './pages/Singer';
import SingerView from './pages/SingerView';
import Search from './pages/Search';
import Profile from './pages/Profile';
import Feedback from './pages/Feedback';
import About from './pages/About';
import Reklama from './pages/Reklama';
import Partner from './pages/Partner';
import Agreement from './pages/Agreement';
import PersonView from './pages/PersonView';
import Test from './pages/Test';
import { createBrowserHistory } from 'history';
import ReactGA from 'react-ga';
import Tv from './pages/Tv';
import TvView from './pages/TvView';

const history = createBrowserHistory();

ReactGA.initialize('UA-60550918-1');
ReactGA.pageview(location.pathname + location.search);

history.listen((location, action) => {
    if (document.getElementById('stat')) {
        var top_js = "1.0"; var top_r = "id=19385&r=" + escape(document.referrer) + "&pg=" + escape(window.location.href); document.cookie = "smart_top=1; path=/"; top_r += "&c=" + (document.cookie ? "Y" : "N");
        top_js = "1.1"; top_r += "&j=" + (navigator.javaEnabled() ? "Y" : "N");
        top_js = "1.2"; top_r += "&wh=" + screen.width + 'x' + screen.height + "&px=" +
            (((navigator.appName.substring(0, 3) == "Mic")) ? screen.colorDepth : screen.pixelDepth);
        top_js = "1.3";

        var top_rat = "&col=340F6E&t=ffffff&p=BD6F6F"; top_r += "&js=" + top_js + "";

        ReactDOM.render(<img src={"http://cnt0.www.uz/counter/collect?" + top_r + top_rat} width="0" height="0" />, document.getElementById('stat'));

        ReactGA.pageview(location.pathname + location.search);
    }

});

const store = createStore(reducers, applyMiddleware(thunk));

let token = localStorage.getItem("token");
let userString = localStorage.getItem("user");

if (token && userString) {
    Axios.interceptors.response.use(response => {
        return response;
    }, error => {
        if (error.response.status === 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            store.dispatch({
                type: USER_LOGOUT,
                user: JSON.parse(userString)
            });
        } else {
            return Promise.reject(error);
        }
    });

    Axios.defaults.headers.common['Authorization'] = "Bearer " + token;

    store.dispatch({
        type: USER_LOGIN,
        user: JSON.parse(userString)
    });
}

ReactDOM.render(
    <Provider store={store}>
    {/* <HashRouter hashType="hashbang"> */}
        <Router history={history}>
            <ScrollToTop>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    draggable
                    pauseOnHover
                />
                <Navbar />
                <Switch>
                    <Route path="/" exact component={Home} />
                    <Route path="/test" exact component={Test} />
                    <Route path="/films" exact component={(props: any) => <Videoclub type={EVideoclub.FILMS} {...props} />} />
                    <Route path="/films/page/:current_page" exact component={(props: any) => <Videoclub type={EVideoclub.FILMS} {...props} />} />
                    <Route path="/films/genre/:genre_id" exact component={(props: any) => <Videoclub type={EVideoclub.FILMS} {...props} />} />
                    <Route path="/films/year/:year" exact component={(props: any) => <Videoclub type={EVideoclub.FILMS} {...props} />} />
                    <Route path="/films/city/:city_id" exact component={(props: any) => <Videoclub type={EVideoclub.FILMS} {...props} />} />
                    <Route path="/serials/page/:current_page" exact component={(props: any) => <Videoclub type={EVideoclub.SERIALS} {...props} />} />
                    <Route path="/serials/genre/:genre_id" exact component={(props: any) => <Videoclub type={EVideoclub.SERIALS} {...props} />} />
                    <Route path="/serials/year/:year" exact component={(props: any) => <Videoclub type={EVideoclub.SERIALS} {...props} />} />
                    <Route path="/serials/city/:city_id" exact component={(props: any) => <Videoclub type={EVideoclub.SERIALS} {...props} />} />
                    <Route path="/serials" exact component={(props: any) => <Videoclub type={EVideoclub.SERIALS} {...props} />} />
                    <Route path="/trailers" exact component={(props: any) => <Videoclub type={EVideoclub.TRAILERS} {...props} />} />
                    <Route path="/film/:name/:media_id" component={(VideoclubView)} />
                    <Route path="/serial/:name/:media_id" component={(SerialView)} />
                    <Route path="/clip/:name/:media_id" component={(VideoclipView)} />
                    <Route path="/album/:name/:media_id" component={(AlbumView)} />
                    <Route path="/football/:name/:media_id" component={(FootballView)} />
                    <Route path="/concert/:name/:media_id" component={(ConcertView)} />
                    <Route path="/festival/:name/:media_id" component={(FestivalView)} />
                    <Route path="/show-business/:name/:media_id" component={(ShowBusinessView)} />
                    <Route path="/search/:query" component={(Search)} />
                    <Route path="/music" exact component={Music} />
                    <Route path="/music/:genre_id" exact component={Music} />
                    <Route path="/albums" exact component={Album} />
                    <Route path="/clips" exact component={Videoclip} />
                    <Route path="/clips/:genre_id" exact component={Videoclip} />
                    <Route path="/concerts" exact component={Concert} />
                    <Route path="/concerts/:genre_id" exact component={Concert} />
                    <Route path="/festivals" exact component={Festival} />
                    <Route path="/festivals/:genre_id" exact component={Festival} />
                    <Route path="/wallpapers" exact component={Wallpaper} />
                    <Route path="/tv" exact component={Tv} />
                    <Route path="/tv/:id" exact component={TvView} />
                    <Route path="/show-business" exact component={ShowBusiness} />
                    <Route path="/football" exact component={Football} />
                    <Route path="/singers" exact component={Singer} />
                    <Route path="/singer/:name/:person_id" exact component={SingerView} />
                    <Route path="/person/:person_id" exact component={PersonView} />
                    <Route path="/profile" exact component={Profile} />
                    <Route path="/signup" exact component={Signup} />
                    <Route path="/login" exact component={Login} />
                    <Route path="/feedback" exact component={Feedback} />
                    <Route path="/about" exact component={About} />
                    <Route path="/agreement" exact component={Agreement} />
                    <Route path="/partners" exact component={Partner} />
                    <Route path="/reklama" exact component={Reklama} />
                    <NotFound />
                </Switch>
                <Footer />
                <AudioPlayer />
                <div className="static-modal">
                    <AuthModal />
                </div>
                <a className="back-to-top ">
                    <i className="fa fa-angle-up text-white fa-2x"></i>
                </a>

            </ScrollToTop>
        </Router>
    {/* </HashRouter> */}
    </Provider>,
    document.getElementById('root')
);
